/*=============================================== TimepickerPage ===============================================*/

import { useState } from "react"
import { Timepicker } from "tsx-library-julseb"
import type { TimepickerHoursTypes } from "tsx-library-julseb/types"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import {
    inputIcon,
    iconBoxicon,
    inputBackgroundColor,
    listDirection,
    inputVariants,
    inputLabel,
    validationObject,
} from "data"

const TimepickerPage = () => {
    const [selectedTime, setSelectedTime] =
        useState<TimepickerHoursTypes>("06:00")

    const items: ItemType[] = [
        {
            content: (
                <Timepicker
                    selectedTime={selectedTime}
                    setSelectedTime={setSelectedTime}
                    minTime="06:00"
                    maxTime="18:00"
                />
            ),
            code: 'const [selectedTime, setSelectedTime] = useState("06:00")\n\n<Timepicker\n    selectedTime={selectedTime}\n    setSelectedTime={setSelectedTime}\n    minTime="06:00"\n    maxTime="18:00"\n/>',
            codeTs: 'const [selectedTime, setSelectedTime] = useState<TimepickerHoursTypes>("06:00")\n\n<Timepicker\n    selectedTime={selectedTime}\n    setSelectedTime={setSelectedTime}\n    minTime="06:00"\n    maxTime="18:00"\n/>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "selectedTime",
            type: "string",
            required: true,
        },
        {
            subtitle: "setSelectedTime",
            type: "function",
            required: true,
        },
        {
            subtitle: "step",
            type: "string",
            possible: ["1h", "30min", "15min", "1min"],
        },
        {
            subtitle: "minTime",
            type: "string",
        },
        {
            subtitle: "maxTime",
            type: "string",
        },
        ...inputIcon(),
        {
            subtitle: "iconClock",
            type: "string",
            default: iconBoxicon("time"),
        },
        inputBackgroundColor(),
        listDirection(),
        inputVariants("inputVariant"),
        ...inputLabel(),
        ...validationObject(),
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default TimepickerPage
